<template>
  <main class="landing">
    <div class="card">
      <div class="mascotte-container">
        <img class="mascotte" src="~@/assets/images/mascotte@0.5x.png" alt="" />
      </div>
      <h1>Maddy Art Club</h1>
      <login v-if="!isLoggedIn" />
      <router-link v-else :to="{ name: 'home' }">Go to dashboard</router-link>
    </div>
  </main>
</template>

<script>
import Login from '@/components/login/Login.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'landing',
  components: { Login },
  mounted() {
    if (this.$route.params.logout) {
      this.$gtag.event('logout', {
        event_category: 'engagement',
        event_label: 'User logout',
      });
      this.logout();
    }
    if (this.isLoggedIn) {
      this.$router.push({ name: 'home' });
    }
    document.getElementById('app').style.paddingTop = '0';
  },
  watch: {
    isLoggedIn(newVal) {
      if (newVal === true) {
        this.$router.push({ name: 'home' });
      }
    },
  },
  methods: {
    ...mapActions('auth', ['logout']),
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
};
</script>

<style lang="scss" scoped>
.landing {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1;
  background-size: cover;

  @media (orientation: landscape) {
    background-image: url('~@/assets/images/splash_desktop.jpg');
    background-position: center bottom;
  }

  @media (orientation: portrait) {
    background-image: url('~@/assets/images/splash_mobile.jpg');
    background-position: center top;
  }

  .card {
    text-align: center;
    width: calc(100% - 4rem);
    max-width: 400px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(4px);
    border-radius: 8px;
    margin: 0 2rem;
    position: relative;

    h1 {
      padding: 0;
      margin: 0;
      margin-top: 1rem;
      font-size: 2.5rem;
      font-weight: 400;
    }

    .mascotte-container {
      width: 128px;
      height: 128px;
      background: color('secondary');
      background-size: cover;
      border-radius: 64px 64px;
      border: 4px solid color('secondary');
      display: flex;
      overflow: hidden;
      margin: 2rem auto 0;
      justify-content: center;
    }
    .mascotte {
      max-width: 90%;
      align-self: flex-end;
    }
  }
}
</style>
